import LocationSwitcher from '../LocationSwitcher';

const ProviderHeaderActions = () => {
	return (
		<div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
			<LocationSwitcher />
		</div>
	);
};

export default ProviderHeaderActions;
